import useConfiguration from '~/configuration/use-configuration';
import { basePathname } from '~/utils/pathname';

const useBasePathname = (fallback?: string) => {
	const { license } = useConfiguration();
	return basePathname(license, fallback);
};

export default useBasePathname;
